module.exports = __webpack_public_path__ + "static/media/ear-muffs.c9e41f93.svg";